import React from "react";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/i18n";
import WhatsAppDialog from "@/components/WhatsAppDialog";

export const WhatsAppChatButton = () => {
  const { lang } = useLang();
  const msg =
    lang === "fr"
      ? "Bonjour ANYANG BETI 👋 J'aimerais échanger avec vous."
      : "Hello ANYANG BETI 👋 I would like to chat with you.";
  return (
    <div className="fixed bottom-5 right-5 z-40 group" data-testid="whatsapp-float">
      <span
        className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping [animation-duration:2.8s]"
        aria-hidden="true"
      />
      <WhatsAppDialog
        message={msg}
        triggerTestId="whatsapp-chat-button"
        triggerClassName="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(0,0,0,0.45)] hover:scale-110 active:scale-95 transition-transform duration-300"
        triggerIcon={<MessageCircle size={26} />}
        triggerLabel=""
        title={lang === "fr" ? "Discuter avec Anyang Beti" : "Chat with Anyang Beti"}
        description={
          lang === "fr"
            ? "Envoyez-nous un message WhatsApp — nous répondons rapidement."
            : "Send us a WhatsApp message — we reply quickly."
        }
      />
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-ab-ebony/90 backdrop-blur-xl px-3 py-1.5 rounded-full text-xs text-ab-ivory border border-ab-gold/20 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden md:block">
        {lang === "fr" ? "Discuter sur WhatsApp" : "Chat on WhatsApp"}
      </span>
    </div>
  );
};

export default WhatsAppChatButton;
